/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiDocumentSchemasContractsSchemasGet$Json } from '../fn/document-schemas/api-document-schemas-contracts-schemas-get-json';
import { ApiDocumentSchemasContractsSchemasGet$Json$Params } from '../fn/document-schemas/api-document-schemas-contracts-schemas-get-json';
import { apiDocumentSchemasContractsSchemasGet$Plain } from '../fn/document-schemas/api-document-schemas-contracts-schemas-get-plain';
import { ApiDocumentSchemasContractsSchemasGet$Plain$Params } from '../fn/document-schemas/api-document-schemas-contracts-schemas-get-plain';
import { apiDocumentSchemasSchemaPost$Json } from '../fn/document-schemas/api-document-schemas-schema-post-json';
import { ApiDocumentSchemasSchemaPost$Json$Params } from '../fn/document-schemas/api-document-schemas-schema-post-json';
import { apiDocumentSchemasSchemaPost$Plain } from '../fn/document-schemas/api-document-schemas-schema-post-plain';
import { ApiDocumentSchemasSchemaPost$Plain$Params } from '../fn/document-schemas/api-document-schemas-schema-post-plain';
import { apiDocumentSchemasSchemasGet$Json } from '../fn/document-schemas/api-document-schemas-schemas-get-json';
import { ApiDocumentSchemasSchemasGet$Json$Params } from '../fn/document-schemas/api-document-schemas-schemas-get-json';
import { apiDocumentSchemasSchemasGet$Plain } from '../fn/document-schemas/api-document-schemas-schemas-get-plain';
import { ApiDocumentSchemasSchemasGet$Plain$Params } from '../fn/document-schemas/api-document-schemas-schemas-get-plain';
import { DocumentSchema } from '../models/document-schema';
import { DocumentSchemaResponseModel } from '../models/document-schema-response-model';

@Injectable({ providedIn: 'root' })
export class DocumentSchemasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDocumentSchemasSchemaPost()` */
  static readonly ApiDocumentSchemasSchemaPostPath = '/api/DocumentSchemas/schema';

  /**
   * Create a document schema.
   *
   * Registers a new document schema definition. The schema declares the structured fields the AI extraction pipeline should pull from uploaded documents of this type. Restricted to admins and relationship managers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentSchemasSchemaPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentSchemasSchemaPost$Plain$Response(params: ApiDocumentSchemasSchemaPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSchema>> {
    const obs = apiDocumentSchemasSchemaPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a document schema.
   *
   * Registers a new document schema definition. The schema declares the structured fields the AI extraction pipeline should pull from uploaded documents of this type. Restricted to admins and relationship managers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocumentSchemasSchemaPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentSchemasSchemaPost$Plain(params: ApiDocumentSchemasSchemaPost$Plain$Params, context?: HttpContext): Observable<DocumentSchema> {
    const resp = this.apiDocumentSchemasSchemaPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentSchema>): DocumentSchema => r.body)
    );
  }

  /**
   * Create a document schema.
   *
   * Registers a new document schema definition. The schema declares the structured fields the AI extraction pipeline should pull from uploaded documents of this type. Restricted to admins and relationship managers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentSchemasSchemaPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentSchemasSchemaPost$Json$Response(params: ApiDocumentSchemasSchemaPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSchema>> {
    const obs = apiDocumentSchemasSchemaPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a document schema.
   *
   * Registers a new document schema definition. The schema declares the structured fields the AI extraction pipeline should pull from uploaded documents of this type. Restricted to admins and relationship managers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocumentSchemasSchemaPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiDocumentSchemasSchemaPost$Json(params: ApiDocumentSchemasSchemaPost$Json$Params, context?: HttpContext): Observable<DocumentSchema> {
    const resp = this.apiDocumentSchemasSchemaPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentSchema>): DocumentSchema => r.body)
    );
  }

  /** Path part for operation `apiDocumentSchemasSchemasGet()` */
  static readonly ApiDocumentSchemasSchemasGetPath = '/api/DocumentSchemas/schemas';

  /**
   * List all document schemas.
   *
   * Returns every document schema known to the system. Used to populate document-type pickers in the client and admin UI.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentSchemasSchemasGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasSchemasGet$Plain$Response(params?: ApiDocumentSchemasSchemasGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchema>>> {
    const obs = apiDocumentSchemasSchemasGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List all document schemas.
   *
   * Returns every document schema known to the system. Used to populate document-type pickers in the client and admin UI.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocumentSchemasSchemasGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasSchemasGet$Plain(params?: ApiDocumentSchemasSchemasGet$Plain$Params, context?: HttpContext): Observable<Array<DocumentSchema>> {
    const resp = this.apiDocumentSchemasSchemasGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentSchema>>): Array<DocumentSchema> => r.body)
    );
  }

  /**
   * List all document schemas.
   *
   * Returns every document schema known to the system. Used to populate document-type pickers in the client and admin UI.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentSchemasSchemasGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasSchemasGet$Json$Response(params?: ApiDocumentSchemasSchemasGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchema>>> {
    const obs = apiDocumentSchemasSchemasGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List all document schemas.
   *
   * Returns every document schema known to the system. Used to populate document-type pickers in the client and admin UI.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocumentSchemasSchemasGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasSchemasGet$Json(params?: ApiDocumentSchemasSchemasGet$Json$Params, context?: HttpContext): Observable<Array<DocumentSchema>> {
    const resp = this.apiDocumentSchemasSchemasGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentSchema>>): Array<DocumentSchema> => r.body)
    );
  }

  /** Path part for operation `apiDocumentSchemasContractsSchemasGet()` */
  static readonly ApiDocumentSchemasContractsSchemasGetPath = '/api/DocumentSchemas/contracts-schemas';

  /**
   * List contract document schemas.
   *
   * Returns the subset of document schemas that represent contracts (e.g. policies, mortgages). Used by the contracts section of the client portal.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentSchemasContractsSchemasGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasContractsSchemasGet$Plain$Response(params?: ApiDocumentSchemasContractsSchemasGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchemaResponseModel>>> {
    const obs = apiDocumentSchemasContractsSchemasGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List contract document schemas.
   *
   * Returns the subset of document schemas that represent contracts (e.g. policies, mortgages). Used by the contracts section of the client portal.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocumentSchemasContractsSchemasGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasContractsSchemasGet$Plain(params?: ApiDocumentSchemasContractsSchemasGet$Plain$Params, context?: HttpContext): Observable<Array<DocumentSchemaResponseModel>> {
    const resp = this.apiDocumentSchemasContractsSchemasGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentSchemaResponseModel>>): Array<DocumentSchemaResponseModel> => r.body)
    );
  }

  /**
   * List contract document schemas.
   *
   * Returns the subset of document schemas that represent contracts (e.g. policies, mortgages). Used by the contracts section of the client portal.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocumentSchemasContractsSchemasGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasContractsSchemasGet$Json$Response(params?: ApiDocumentSchemasContractsSchemasGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchemaResponseModel>>> {
    const obs = apiDocumentSchemasContractsSchemasGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List contract document schemas.
   *
   * Returns the subset of document schemas that represent contracts (e.g. policies, mortgages). Used by the contracts section of the client portal.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocumentSchemasContractsSchemasGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocumentSchemasContractsSchemasGet$Json(params?: ApiDocumentSchemasContractsSchemasGet$Json$Params, context?: HttpContext): Observable<Array<DocumentSchemaResponseModel>> {
    const resp = this.apiDocumentSchemasContractsSchemasGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DocumentSchemaResponseModel>>): Array<DocumentSchemaResponseModel> => r.body)
    );
  }

}
